import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiResponse } from '@/app/common/types/common';
import customFetchBase from '@/app/common/utils/customFetchBase';
import {
  ExportTableRequest,
  GetKeywordsByIdRequest,
  SearchVolumeTrendRequest,
  SearchVolumeTrendResponse,
  StartVolumeData,
  StartVolumeRequest,
  StartVolumeResponse,
  ClusterFromTaskRequest,
  ClusterFromTaskResponse
} from '@/app/KeywordResearch/types/googleAdsApiTypes';
import { getBaseApiPath } from '@/app/common/api/config';

const searchVolumeApi = createApi({
  reducerPath: 'searchVolumeApi',
  tagTypes: ['SearchVolumeChart', 'SearchVolumeHistory'],
  baseQuery: (...args: unknown[]) =>
    customFetchBase(getBaseApiPath(), ...args),
  endpoints: build => ({
    getSearchVolumeDetailsChart: build.query<
      SearchVolumeTrendResponse,
      SearchVolumeTrendRequest
    >({
      query: (body: SearchVolumeTrendRequest) => ({
        url: '/google_ads/v2/keyword_search_volume/keyword_search_volumes_trend',
        method: 'POST',
        body
      }),
      providesTags: ['SearchVolumeChart']
    }),
    getHistorySearchVolume: build.query<ApiResponse<StartVolumeData>, void>({
      query: () => ({
        url: '/google_ads/v2/keyword_search_volume/history',
        method: 'POST'
      }),
      providesTags: ['SearchVolumeHistory']
    }),
    getSearchVolumeFunc: build.mutation<
      ApiResponse<unknown>,
      GetKeywordsByIdRequest
    >({
      query: (body: GetKeywordsByIdRequest) => ({
        url: '/google_ads/v2/keyword_search_volume/keywords/get_by_id',
        method: 'POST',
        body
      })
    }),
    startVolume: build.mutation<StartVolumeResponse, StartVolumeRequest>({
      query: (body: StartVolumeRequest) => ({
        url: '/google_ads/v3/keyword_search_volume/send_request',
        method: 'POST',
        body
      })
    }),
    exportTable: build.mutation<ApiResponse<unknown>, ExportTableRequest>({
      query: (body: ExportTableRequest) => ({
        url: '/export',
        method: 'POST',
        body
      })
    }),
    clusterSearchVolumeFromTask: build.mutation<
      ClusterFromTaskResponse,
      ClusterFromTaskRequest
    >({
      query: (body: ClusterFromTaskRequest) => ({
        url: '/google_ads/v3/keyword_search_volume/cluster',
        method: 'POST',
        body
      })
    })
  })
});

export const {
  useGetHistorySearchVolumeQuery,
  useGetSearchVolumeFuncMutation,
  useStartVolumeMutation,
  useLazyGetSearchVolumeDetailsChartQuery,
  useClusterSearchVolumeFromTaskMutation
} = searchVolumeApi;

export default searchVolumeApi;
